import React from 'react'
import E404 from "../images/Error404.png"
import { Link } from 'react-router-dom'

const Error404 = () => {
  return (
    <>
    <div style={{
      display:'grid',
      placeItems:'center'
    }}>

    <img style={{
      maxWidth:'60%',
      maxHeight:'60%',
    }} src={E404} alt="" />

    <Link style={{
      textDecoration:'none',
      color:'white'
    }} to={'/'} className='submit-btn'> GO BACK</Link>
    </div>
    </>
  )
}

export default Error404